import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginGuard } from './shared/guards/login.guard';
import { PageAccessGuard } from './shared/guards/page-access.guard';
import { RestrictedGuard } from './shared/guards/restricted.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'register',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'forgot-password',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage)
  },
  {
    path: 'signup/pswdset/token/:token',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/forgot-password-token/forgot-password-token.page').then( m => m.ForgotPasswordTokenPage) 
  },
  {
    path: 'epayments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: 'redirecthome/failure' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'redirecthome/success' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'redirecthome' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'powercash21result' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'resultdeposit/status/failed' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'resultdeposit/status/success' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'isignthisresult' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
    ]
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule),
    data: { preload: true },
  },
  {
    path: 'payments/uploadproofofcryptos',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule)
  },
  {
    path: 'payments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    children: [
      {path: '', loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule),data: { preload: true },},
      {path: '**',loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule),data: { preload: true },},
    ]
  },
  {
    path: 'complete-profile',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/complete-profile-v2/complete-profile-v2.module').then( m => m.CompleteProfileV2PageModule)
  },
  {
    path: 'upload',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/upload-docs-v2/upload-docs-v2.module').then( m => m.UploadDocsV2PageModule)
  },
  {
    path: 'view-more',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: '' , loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)},
      {path: '**' , loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)},
    ]
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/push-notifications/push-notifications.module').then( m => m.PushNotificationsPageModule)
  },
  {
    path: 'signup/verifyemail/token/:token',
    loadChildren: () => import('./pages/welcome/verify-email/verify-email.module').then( m => m.VerifyEmailPageModule)
  },
  {
    path: 'version',
    loadChildren: () => import('./pages/version/version.module').then( m => m.VersionPageModule)
  },
  {
    path: 'rebates-offers',
    canActivate: [AuthGuard, RestrictedGuard],
    loadChildren: () => import('./pages/rebates/rebates.module').then( m => m.RebatesPageModule)
  },
  {
    path: 'ledger-report',
    canActivate: [AuthGuard, RestrictedGuard],
    loadChildren: () => import('./pages/ledger-report/ledger-report.module').then( m => m.LedgerReportPageModule)
  },
  {    path: 'cashback',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-cashback/bi-cashback.module').then( m => m.BiCashbackPageModule)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: '',loadChildren: () => import('./pages/bi-reports/bi-reports.module').then( m => m.BiReportsPageModule)},
      {path: '**',loadChildren: () => import('./pages/bi-reports/bi-reports.module').then( m => m.BiReportsPageModule)}   
    ]
    
  },
  {
    path: 'reports/client-summary',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/client-summary/client-summary.module').then( m => m.ClientSummaryPageModule)
  },
  {
    path: 'reports/leads-dashboard',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/lead-dashboard/lead-dashboard.module').then( m => m.LeadDashboardPageModule)
  },
  {
    path: 'reports/client-trading-history-statements',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/client-trading-history-statements/client-trading-history-statements.module').then( m => m.ClientTradingHistoryStatementsPageModule)
  },
  {
    path: 'reports/lots-report',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/lots-report/lots-report.module').then( m => m.LotsReportPageModule)
  },
  {
    path: 'reports/volume-client',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/volume-client/volume-client.module').then( m => m.VolumeClientPageModule)
  },
  {
    path: 'reports/deposit-and-withdrawal',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/deposit-and-withdrawal/deposit-and-withdrawal.module').then( m => m.DepositAndWithdrawalPageModule)
  },
  {
    path: 'reports/client-payments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/client-payments/client-payments.module').then( m => m.ClientPaymentsPageModule)
  },
  {
    path: 'reports/rebates',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/rebate-info/rebate-info.module').then( m => m.RebateInfoPageModule)
  },
  {
    path: 'reports/rebates-per-symbol',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/rebate-per-symbol/rebate-per-symbol.module').then( m => m.RebatePerSymbolPageModule)
  },
  {
    path: 'reports/sub-bi-payouts',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/sub-bi-payouts/sub-bi-payouts.module').then( m => m.SubBiPayoutsPageModule)
  },
  {
    path: 'reports/multi-tier-report',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/bi-reports/multi-tier-report/multi-tier-report.module').then( m => m.MultiTierReportPageModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./pages/maintenance/maintenance.module').then( m => m.MaintenancePageModule)
  },
  {
    path: 'recovertoken/token',
    loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)
  },
  {
    path: 'recovertoken/token/:token',
    loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)
  },
  {
    path: 'refreshment',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/refreshment-time/refreshment-time.module').then( m => m.RefreshmentTimePageModule)
  },
  {
    path: 'recovertoken/token/:token/:returnUrl',
    children : [
      {path: '' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)},
      {path: ':id' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)},
      {path: '**' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)}
    ]
  },
  {
    // redirects @all unknown urls
    // needs to be last in routes array to work properly
    path: '**',
    redirectTo: 'dashboard'
  },
  
 
];

// selective-preloading.strategy.ts
import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === false || !this.shouldPreloadOnCurrentConnection()) {
      return of(null);
    }
    return of(null).pipe(
      delay(this.getPreloadDelay()),
      switchMap(() => load())
    );
  }

  private shouldPreloadOnCurrentConnection(): boolean {
    const connection = (navigator as any)?.connection ?? (navigator as any)?.mozConnection ?? (navigator as any)?.webkitConnection;

    return !connection?.saveData;
  }

  private getPreloadDelay(): number {
    const connection = (navigator as any)?.connection ?? (navigator as any)?.mozConnection ?? (navigator as any)?.webkitConnection;

    switch (connection?.effectiveType) {
      case 'slow-2g':
      case '2g':
      case '3g':
        return 2000;
      default:
        return 500;
    }
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: SelectivePreloadingStrategy})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
